import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '../common/vuex/store'
import VueResource from 'vue-resource'
import VueRaven from 'vue-raven'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons'
import { faCheck, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { VueMaskDirective } from 'v-mask'
import { APP_CONFIG } from './const/config.const'
import { APP_ENV } from '@/common/const/env.const'
import { TOPUP_CONFIG } from './const/topup.const'
import { MATOMO_EVENTS_CONFIG } from './const/piwik.const'
import { ToolsClass } from '@/common/class/tools.class'
import { BmPrivacyVue } from '@bm/privacy'

library.add(faTrashAlt, faSpinner, faCheck)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.directive('mask', VueMaskDirective)

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(BmPrivacyVue.default, { locale: 'pl', env: process.env.NODE_ENV })

Vue.prototype.$VUE_APP_OPERATOR = APP_CONFIG.OPERATOR
Vue.prototype.$VUE_APP_CONFIG = APP_CONFIG[process.env.NODE_ENV]
Vue.prototype.$VUE_TOPUP_CONFIG = TOPUP_CONFIG
Vue.prototype.$VUE_MATOMO_EVENTS_CONFIG = MATOMO_EVENTS_CONFIG

if (process.env.NODE_ENV === APP_ENV.production) {
  Vue.use(VueRaven, {
    dsn: APP_CONFIG[process.env.NODE_ENV].SENTRY,
    environment: process.env.NODE_ENV
  })
}

if (process.env.NODE_ENV === APP_ENV.development && process.env.VUE_APP_USE_MOCK === 'true') {
  const { worker } = require('../mock/browser')
  worker.start()
}

const storeInit = store.dispatch('getUserInitData')
router.beforeEach((to, from, next) => {
  ToolsClass.scrollToTop()
  storeInit.finally(next).catch(() => {})
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
